import './Modals.scss';
import React from 'react';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import PropTypes from 'prop-types';

const OnlineValidationModal = ({ icon, head, body, withButton, buttonText, onAccept }) => {
    return (
        <div className="identify-modal__container">
            <div className="row">
                <div className="col-md-12 center-icon">{icon}</div>
            </div>

            <div className="row">
                <div className="col-md-12 center-icon">
                    <p className="identify-modal__modal-body-title">{head}</p>
                </div>
            </div>

            <ConditionalToggling condition={body}>
                <div className="row">
                    <div className="col-md-12 center-icon">
                        <p className="identify-modal__modal-body-text font-paragraph">{body}</p>
                    </div>
                </div>
            </ConditionalToggling>

            <ConditionalToggling condition={withButton}>
                <div className="identify-modal__modal-buttons">
                    <button className="form__button form__button-secondary error_button" onClick={onAccept}>
                        {buttonText}
                    </button>
                </div>
            </ConditionalToggling>
        </div>
    );
};

OnlineValidationModal.propTypes = {
    withButton: PropTypes.bool,
    icon: PropTypes.object,
    head: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    body: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    onAccept: PropTypes.func,
};

export default OnlineValidationModal;
